import React from 'react';
import { Doughnut, Bar, HorizontalBar } from 'react-chartjs-2';
import ReactSpeedometer from "react-d3-speedometer";
import completenessRating from './completenessRating';

const CarrierViewComponent = (props) => {

    console.log(completenessRating);

    const { riskData, quoteScores, messages, happyPath } = props;
    const style = {
        animationDelay: '.5s',
        color: '#9c9c9c'
    };

    function convertFraudIndicator() {

    }

    let riskScore = null,
        decileScore = null,
        riskGroup = null;

    if (happyPath) {
        riskScore = 1500;
        decileScore = 1;
        riskGroup = 'Good';

    }
    else {
        riskScore = riskData.totalScore;
        decileScore = riskData.scoreDecile.code;
        riskGroup = riskData.riskGroup;
    }

    const donutBorder = decileScore == 10? 'red':'#1da83f';

    const dataDonut = {
        labels: ["Risk", "No Risk"],
        datasets: [{
            //label: '# of Votes',
            data: [decileScore, (10 - decileScore)],
            backgroundColor: [
                'red',
                donutBorder
            ],
            borderColor: [
                null,
                donutBorder
            ],
            borderWidth: 1,
            options: {
                responsive: true,
                labels: {
                    display: true,
                    onClick: null
                },
                legends: {
                    display: true,
                    onClick: null,
                    onHover: null
                }
            }
        }]
    }

    function setCompletenessBar(currentScoreDescription) {
        for (var item in completenessRating) {
            if (completenessRating[item] === currentScoreDescription) {
                return Number(item);
            }
        }
    }

    const completionScoreMax = 14;

    console.log(completionScoreMax, ' is the max sore');
    const currentCompletionScore = setCompletenessBar(quoteScores.applicationCompletenessCode);

    const dataHorizontalBar = {
        //labels: ["Risk"],
        datasets: [{
            //label: '# of Votes',
            data: [(100-(currentCompletionScore*6.66))],
            backgroundColor: [
                '#1da83f',
            ],
            borderColor: [
                '#1da83f',
            ],
            borderWidth: 1,
            options: {
                responsive: true,
                labels: {
                    display: true,
                    onClick: null
                },
                legend: {
                    display: true,
                    onClick: null,
                    onHover: null
                }
            }
        }]
    }

    return (
        <div style={style} className="card carrierView animated flipInX">
            <div className="card-body">
                <div style={{
                    textAlign: 'center'
                }}>
                    <h4>LightSpeed Decisioning</h4>
                    <ul>
                        <li>
                            <strong>Risk Score </strong>
                            <div style={{
                                width: "100%", height: "180px", background: "#fff"
                            }}>
                                <ReactSpeedometer
                                    fluidWidth={true}
                                    forceRender={true}
                                    ringWidth={20}
                                    startColor="green"
                                    endColor="red"
                                    value={Number(riskScore)}
                                    maxValue={Number('6000')} />
                            </div>
                            {/*
                            <p>
                                {riskData.scoreDecile ? riskData.scoreDecile.description : ''}                                
                            </p>
                             */}
                        </li>
                        <li>
                            <strong>Decile</strong>
                            {/*
                            {riskData.scoreDecile ? riskData.scoreDecile.code : ''}
                            */} {decileScore} out of 10
                            {/*
                            <p>{riskData.riskGroup}</p>
                             */}
                            <p>{riskGroup}</p>
                            <Doughnut data={
                                dataDonut
                            }
                                legend={{
                                    display: true,
                                    onClick: null,
                                    onHover: null
                                }}
                            />
                        </li>
                        <li>
                            <strong>Fraud Indicator</strong> {riskData.isFraudIndicator === null ? null : riskData.isFraudIndicator.toString()}
                        </li>
                        <li>
                            <strong>Application Completeness Code</strong> {quoteScores ? quoteScores.applicationCompletenessCode : ''}
                        
                            <HorizontalBar
                                data={dataHorizontalBar}
                                options={{
                                    scales: {
                                        xAxes: [{
                                            ticks: {
                                                beginAtZero: true,
                                                autoSkip: false,
                                                steps: 10,
                                                stepValue: 1,
                                                max: 100
                                            },
                                            maxBarThickness: 1,
                                            barThickness: 2,
                                            categoryPercentage: 1
                                        }]
                                    }
                                }}
                                
                                legend={{
                                    display: false
                                }}

                                 />
                                
                        </li>
                        <li>
                            <strong>Rating Completeness Code</strong> {quoteScores ? quoteScores.ratingCompletenessCode : ''}
                        </li>
                    </ul>
                </div>
            </div>
        </div>

    )
};

export default CarrierViewComponent;


// WEBPACK FOOTER //
// ./src/SectionTitle/components/CarrierViewComponent.js